// src/components/HeroSection.jsx
import React from 'react';
// import { useNavigate } from 'react-router-dom';
import bannerImage from '../assets/heda_banner_4.jpg';

function HomePageBanner() {
  // const navigate = useNavigate();
  return (
    <div
      className="
        relative h-[200px] w-full flex flex-col items-center justify-center text-center text-white
        bg-center bg-cover
      "
      style={{
        backgroundImage: `url(${bannerImage})`,
      }}
    >

      {/* <div className="absolute inset-0 bg-black bg-opacity-10 z-0" /> */}
      <div className="absolute inset-0 bg-black bg-opacity-20 z-0" />
      
      <div className="relative z-10 px-4">
        {/* <h1 className="text-4xl md:text-5xl font-bold font-ec mb-4">和 達 法 律 事 務 所</h1> */}
        {/* <h1 className="text-4xl md:text-5xl font-bold font-ec mb-4">Heda Attorney-at-Law</h1> */}
        <p className="text-2xl md:text-4xl font-ec font-light tracking-wide text-white leading-relaxed drop-shadow-md">
          事無大小以和為貴<br/>學海無涯達者為先
        </p>
        {/* <div className="relative z-10 px-4">
          <button
            onClick={() => navigate('/contact')}
            className="mt-100 px-6 py-3 bg-[#D8C4B6] text-black font-semibold rounded hover:bg-[#cbb9a8] transition"
          >
            聯絡我們
          </button>
        </div> */}
      </div>
    </div>
  );
}

export default HomePageBanner;
